let key = 'upulse_system_update';

export const setKey = (_key) => {
  key = _key;
};

export const getItem = () => localStorage.getItem(key);

export const setItem = (data) => localStorage.setItem(key, data);

export const clearItem = () => localStorage.setItem(key, undefined);

export const removeItem = () => localStorage.removeItem(key);
